// extracted by mini-css-extract-plugin
module.exports = {"sortable-ghost":"GridBox_sortable-ghost__2wr0l","GridBox":"GridBox_GridBox__TgD8o"};